import { EventBus } from '../../event-bus';
import { orderService } from '../../services/OrderService';

const state = {
    currentOrderId: 0,
    order: {},
    orderLoaded: false,
    selectedOffer: {},
};

const getters = {
    currentOrderId: (state) => state.currentOrderId,
    currentOrderTypeId: (state) => state.order.OrderTypeId,
    currentOrderOffer: (state) => {
        if (state.order.SelectedOfferId != null) {
            return state.order.Offers.find(o => o.Id == state.order.SelectedOfferId);
        }
    },

    order: (state) => state.order,
    owner: (state) => state.order.Owner,
    company: (state) => state.order.Owner.Company,
    person: (state) => state.order.Owner.Person,
    selectedOffer: (state) => state.selectedOffer,

    offers: (state) => state.order.Offers,

    ownerAddress: (state) => state.order.Owner.Address,
    propertyAddress: (state) => {
        if (state.order.Property == null)
            return null;
        else
            return state.order.Property.Address;
    },

    vehicle: (state) => state.order.Vehicle,
    property: (state) => state.order.Property,

    orderLoaded: (state) => state.orderLoaded,
    orderEditable: (state, getters, rootState, rootGetters) => {
        // admins and operators can always edit a order
        // user can edit only not confirmed
        const userHasRole = rootGetters['user/hasRole'];
        return userHasRole('admin') || userHasRole('operator') ||
            (state.order.Status < 2
                && (state.order.RequestStatus < 1 || state.order.RequestStatus === null));

        // STATUS Draft = 0, Request = 1, Confirmed = 2, InProgress = 3, Policy = 4, Canceled = 5, Blocked = 6
        // ROLES admin: 'admin', operator: 'operator', user: 'user'
        // REQUEST STATUS New = 0, InProgress = 1,    Done = 2,
    },

    // order options
    propertyOptions: (state) => state.order.OrderOptions.Property,
    vehicleOptions: (state) => state.order.OrderOptions.Vehicle,
    customOptions: (state) => state.order.OrderOptions.CustomOptions,
};

const actions = {
    getOrder: ({ dispatch, commit, rootGetters }, payload) => {

        return new Promise((resolve, reject) => {
            if (state.orderLoaded) {
                resolve(state.orderLoaded);
            }
            else {
                if (payload.tempOrder) {
                    orderService.getTempOrder(payload.orderId)
                        .then(result => {
                            const orderData = result.data;

                            commit('storeOrder', orderData);
                            commit('setOrderLoaded', true);

                            EventBus.$emit('order_loaded', orderData.ID);

                            resolve(orderData);
                        });
                }
                else {
                    orderService.getOrder(payload.orderId, payload.orderType, payload.renew)
                        .then(result => {

                            var orderData = result.data;

                            //if (payload.checkLocalStorage && payload.orderId === 0) {
                            //    const key = 'last-order-' + payload.orderType;
                            //    if (localStorage.getItem(key) !== null) {
                            //        orderData = JSON.parse(localStorage.getItem(key));
                            //    }
                            //}
                            

                            commit('storeOrder', orderData);
                            commit('setOrderLoaded', true);

                            if (payload.orderId == 0) {
                                commit('setCurrentOrderType', payload.orderType)
                            }

                            EventBus.$emit('order_loaded', orderData.ID);

                            resolve(orderData);
                        });
                }
            }
        });
    },

    saveOrder: ({ commit, rootGetters }) => {
        return new Promise((resolve, reject) => {
            //console.log('vuex.saveOrder');
            orderService.saveOrder(state.order)
                .then(function (result) {
                    const orderData = result.data;
                    commit('storeOrder', orderData);
                    commit('setOrderLoaded', true);

                    resolve(orderData);
                });
        });
    },

    saveTempOrder: ({ commit, rootGetters }) => {
        return new Promise((resolve, reject) => {
            //console.log('vuex.saveTempOrder');

            orderService.saveTempOrder(state.order)
                .then(function (result) {
                    const responseData = result.data;
                    resolve(responseData);
                });
        });
    },

    cacheOrder: ({ commit, rootGetters }) => {
        return new Promise((resolve, reject) => {
            //console.log('vuex.saveOrder');
            orderService.cacheOrder(state.order)
                .then(function (result) {
                    const responseData = result.data;
                    resolve(responseData);
                });
        });
    },

    saveOrderToLocalStorage: () => {
        //console.log('vuex.saveOrder');
        if (state.order !== null) {
            const key = 'last-order-' + state.order.OrderTypeId;
            localStorage.setItem(key, JSON.stringify(state.order))
        }
    },
};

const mutations = {
    clear: (state) => {
        state.currentOrderId = 0;
        state.order = null;
        state.orderLoaded = false;
    },

    setCurrentOrderId(state, orderId) {
        //console.log('vuex.order.selectedOrder = ' + orderId);
        state.order.Id = orderId;
        state.currentOrderId = orderId;
    },
    //CacheKey
    setCurrentOrderCacheKey(state, cacheKey) {
        //console.log('vuex.order.setCurrentOrderCacheKey = ' + cacheKey);
        state.order.CacheKey = cacheKey;
    },

    setCurrentOrderType(state, typeId) {
        //console.log('vuex.order.setCurrentOrderType = ' + typeId);
        state.order.OrderTypeId = typeId;
    },
    setCurrentOrderUser(state, userId) {
        //console.log('vuex.order.setCurrentOrderUser = ' + userId);
        state.order.UserId = userId;
    },

    setCurrentOrderStatus(state, status) {
        //console.log('vuex.order.setCurrentOrderStatus = ' + status);
        state.order.Status = status;
    },
    setCurrentOrderAsSiteOrder(state, isSiteOrder) {
        state.order.IsSiteOrder = isSiteOrder;
    },

    storeOrder: (state, order) => {
        ////console.log('vuex.order.storeOrder Id= ' + JSON.stringify(order));
        state.order = order;
    },

    setOrderLoaded: (state, loaded) => {
        state.orderLoaded = loaded;
    },

    setOwnerAddress: (state, address) => {
        //console.log('vuex.order.setOwnerAddress Id= ' + address.Id);
        state.order.Owner.Address = address;
    },

    setPropertyAddress: (state, address) => {
        //console.log('vuex.order.setPropertyAddress Id= ' + address.Id);
        state.order.Property.Address = address;
    },

    setSelectedOffer: (state, offer) => {
        //console.log('vuex.order.setSelectedOffer');
        state.selectedOffer = offer;
    },

    setOffers: (state, offers) => {

        //console.log('vuex.order.setOffers');

        state.order.Offers = [];

        offers.forEach(function (item) {

            // first period offer
            state.order.Offers.push(JSON.parse(JSON.stringify(item.OfferP1)));

            // second period offer is available
            if (item.OfferP2 != null) {
                state.order.Offers.push(JSON.parse(JSON.stringify(item.OfferP2)));
            }
        })

    },

    setPerson: (state, person) => {
        state.order.Owner.OwnerType = 0; // person
        state.order.Owner.Person = person;
    },

    setProperty: (state, property) => {
        //console.log('vuex.order.setProperty Id= ' + property.Id);
        state.order.Property = property;
    },

    setPropertyOptions: (state, options) => {
        //console.log('vuex.order.setPropertyOptions');
        state.order.OrderOptions.Property = options;
    },
    setCustomOptions: (state, options) => {
        //console.log('vuex.order.CustomOptions');
        state.order.OrderOptions.CustomOptions = options;
    },

    setVehicle: (state, vehicle) => {
        //console.log('vuex.order.setVehicle Id= ' + vehicle.Id);
        state.order.Vehicle = vehicle;
    },
    setVehicleOptions: (state, options) => {
        state.order.OrderOptions.Vehicle = options;
    },

    setCompany: (state, company) => {

        state.order.Owner.OwnerType = 1; // company
        state.order.Owner.Company = company;
    },

    setOwnerType: (state, type) => {
        //console.log('vuex.order.setOwnerType type= ' + type);
        state.order.Owner.OwnerType = type;
    },

    setLeasingCompany: (state, company) => {
        //console.log('vuex.order.owner.LeasingCompany= ' + company);
        if (company == null) {
            state.order.Owner.LeasingCompany = null;
            state.order.Owner.IsLeasing = false;
        }
        else {
            state.order.Owner.LeasingCompany = company.Code;
            state.order.Owner.IsLeasing = true;
        }
    },

    setPropertyOrderFields: (state, orderProperty) => {
        //console.log('vuex.order.setPropertyOrderFields');

        //state.order.StartDate = orderProperty.StartDate;
        state.order.Period = orderProperty.Period;
        state.order.PaymentsNo = orderProperty.PaymentsNo;
        state.order.SelectedInsurers = orderProperty.SelectedInsurers;
        state.order.Remarks = orderProperty.Remarks;
    },

    setGeneralOrderFields: (state, orderProperty) => {
        //console.log('vuex.order.setPropertyOrderFields');

        state.order.StartDate = orderProperty.StartDate;
        state.order.Period = orderProperty.Period;
        state.order.PaymentsNo = orderProperty.PaymentsNo;
        state.order.SelectedInsurers = orderProperty.SelectedInsurers;
        state.order.Remarks = orderProperty.Remarks;
    },

    setVehicleOrderFields: (state, orderVehicle) => {
        //console.log('vuex.order.setVehicleOrderFields');

        state.order.StartDate = orderVehicle.StartDate;
        state.order.EndDate = orderVehicle.EndDate;
        state.order.Period = orderVehicle.Period;
        state.order.PaymentsNo = orderVehicle.PaymentsNo;
        state.order.SelectedInsurers = orderVehicle.SelectedInsurers;
        state.order.Remarks = orderVehicle.Remarks;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
